import Checklist from '@/checklist/models/Checklist';
import ChecklistItem from '@/checklist/models/ChecklistItem';
import { DossierMediaContext } from '@/general/models/MediaContext';
import { JobId } from '@/jobs/models/AbstractJob';
import JobContext from '@/jobs/models/JobContext';
import Survey from '@/satisfaction/models/Survey';
import AbstractContext from '@/shared/models/AbstractContext';
import { DossierTaskContext } from '@/tasks/models/DossierTaskContext';
import WorkPreparationItem from '@/workPreparation/models/WorkPreparationItem';
import Dossier from './Dossier';
import DossierContext from './DossierContext';
import QualityControl from './QualityControl';
import TestDrive from './TestDrive';
import DriveBookingContext from '@/driveBookings/models/DriveBookingContext';

export default class DossierDetailContext extends AbstractContext {
  dossier: Dossier;
  checklists: Array<Checklist> = [];
  qualityControls: Array<QualityControl> = [];
  testDrives: Array<TestDrive> = [];
  workPreparationItems: Array<WorkPreparationItem> = [];
  surveys: Array<Survey> = [];
  taskContext!: DossierTaskContext;
  media!: DossierMediaContext;
  jobContext: JobContext;
  driveBookingContext: DriveBookingContext;

  constructor(
    readonly dossierContext: DossierContext,
  ) {
    super();
    this.dossier = dossierContext.dossier;
    this.jobContext = dossierContext.jobContext;
    this.driveBookingContext = dossierContext.driveBookingContext;
  }

  getChecklistItem(id: JobId): ChecklistItem | undefined {
    for (const checklist of this.checklists) {
      for (const section of checklist.segments) {
        for (const item of section.items) {
          if (item.id === id) return item;
        }
      }
    }
  }

  free(): void {
    super.free();
    this.taskContext.free();
    this.media.free();
  }
}